import { Component, OnInit } from '@angular/core';
import { Store, Select } from '@ngxs/store';
import { Observable } from 'rxjs';
import { Notification, Patient } from 'src/app/core/models';
import { PatientState } from '../core/store/patient/patient.state';
import { FetchOrdersAndReorders } from '../core/store/order/orders.actions';
import { OrdersState } from '../core/store/order/orders.state';
import { Order } from '../core/models';
import { ApiStoreData, CcsSentryError } from '../core/store/utils';
import { EnvService } from '../core/services';
import { FetchNotifications } from '../core/store/notifications/notifications.actions';
import { NotificationsState } from '../core/store/notifications/notifications.state';
import { PharmOrdersState } from '../core/store/pharm-order/pharm-orders.state';
import { PharmOrder } from '../core/models';
import { FetchPharmOrders } from '../core/store/pharm-order/pharm-orders.action';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit {
  @Select(OrdersState.isLoading) isLoading$!: Observable<boolean>;
  @Select(OrdersState.error) error$!: Observable<CcsSentryError | null>;
  @Select(OrdersState.activeOrders) activeOrders$!: Observable<Order[]>;
  @Select(PharmOrdersState.isLoading) isLoadingPharmOrders$!: Observable<boolean>;
  @Select(PharmOrdersState.activePharmOrders) activePharmOrders$!: Observable<PharmOrder[]>;
  @Select(PharmOrdersState.error) errorPharm$!: Observable<CcsSentryError | null>;
  @Select(PatientState.patient) patient$!: Observable<Patient | null>;
  @Select(NotificationsState.notificationsState) notificationsState$!: Observable<ApiStoreData<Notification[]>>;
  billMatrixUrl?: string;
  newLeafPharmacyEnabled: boolean = false;
  //displayPharmacyAcivity: boolean = false;

  constructor(private store: Store, private envService: EnvService) {
    const useInternalPaymentPage = envService.features['makePaymentPage']
      ? envService.features['makePaymentPage'].enabled
      : false;
    this.newLeafPharmacyEnabled = this.envService.features['newLeafPharmacy']?.enabled;
    if (!useInternalPaymentPage) this.billMatrixUrl = envService.billMatrix.url;
  }

  ngOnInit(): void {
    this.store.dispatch(new FetchOrdersAndReorders());

    this.patient$.subscribe((patient) => {
      if (!!patient && patient.isPharmacyPatient && this.newLeafPharmacyEnabled) {
        this.store.dispatch(new FetchPharmOrders());
      }
    });

    if (this.envService.features['notifications']?.enabled) {
      this.store.dispatch(new FetchNotifications());
    }
  }
}
